module.exports = __webpack_public_path__ + "img/arrow-up-left.52824455.svg";